export default "__VITE_ASSET__CfGKF1yl__"